import { CustomElement } from '@aurelia/runtime-html';
import "./db-scrollbar-blogpost.scss";
export const name = "db-scrollbar-blogpost";
export const template = "<div id=\"db-scrollbar-blogpost\" class=\"container\">\n    <div class=\"scrollbar\" id=\"scrollbar-width\" ref=\"scrollbarRef\"></div>\n</div>\n";
export default template;
export const dependencies = [  ];
export const bindables = {};
let _e;
export function register(container) {
  if (!_e) {
    _e = CustomElement.define({ name, template, dependencies, bindables });
  }
  container.register(_e);
}
